export default "__VITE_ASSET__n504LZfIALgId5kLkDy7gA__"